import { useDispatch } from 'react-redux';
import { addNotification } from 'actions/NotificationsActions';
export const useNotify = () => {
    const dispatch = useDispatch();
    return (code, text) => {
        dispatch(addNotification(code, text));
    };
};
